import * as React from 'react';
import clsx from 'clsx';
import { Base } from '@gandi/ui';
import CartContentContext from '../CartContentContext';
import Body from './Body';
import Footer from './Footer';
import Header from './Header';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "DrawerContent-root_2S37N",
  "static": "DrawerContent-static_36VKL"
};
export default function DrawerContent() {
  const {
    openable
  } = React.useContext(CartContentContext);
  return /*#__PURE__*/_jsxs(Base, {
    paddingBottom: openable ? null : 'small',
    flex: true,
    flexCol: true,
    flexGrow1: true,
    className: clsx(styles.root, {
      [styles.static]: !openable
    }),
    children: [/*#__PURE__*/_jsx(Header, {}), /*#__PURE__*/_jsx(Body, {}), /*#__PURE__*/_jsx(Footer, {})]
  });
}